export const siteBrand = {
  name: "黑瓜吃料",
  slogan: "瓜田连线，边吃边聊不落单",
  intro:
    "黑瓜吃料是一个围绕泛娱乐话题的讨论社区。我们把同一个瓜田里散落的观点集中起来，让围观不再是一个人的事。",
  email: "hello@heiguachiliao.com",
  contactText: "投稿爆料、话题推荐、内容纠错都欢迎联系我们。",
};

export const siteStats = [
  { label: "在聊话题", value: "158", suffix: "个", icon: "ri-chat-smile-2-line" },
  { label: "围观群众", value: "12.6", suffix: "万", icon: "ri-group-line" },
  { label: "今日新增观点", value: "3,240", suffix: "条", icon: "ri-flashlight-line" },
  { label: "讨论区连线", value: "24", suffix: "小时", icon: "ri-signal-tower-line" },
];

export const siteFaqs = [
  {
    id: "faq-1",
    question: "黑瓜吃料主要聊些什么内容？",
    answer:
      "我们围绕影视剧、综艺、音乐、时尚、网红动态和幕后花絮这几大类话题展开讨论。每一个话题都会把不同围观群众的观点集中呈现，你既能快速了解热议焦点，也能顺着讨论区继续聊下去。",
  },
  {
    id: "faq-2",
    question: "讨论区的内容是怎么产生的？",
    answer:
      "话题由编辑团队和热心网友共同推荐，讨论区里的观点来自围观群众的自发参与。我们鼓励有依据的讨论，也接受不同立场的碰撞，让话题的氛围更真实、更立体。",
  },
  {
    id: "faq-3",
    question: "我想投稿或者推荐一个话题，该怎么做？",
    answer:
      "可以通过「关于我们」页面的连线表单提交你的投稿或推荐。写清楚话题背景和你关注的点，我们看到后会尽快整理发布，也会在讨论区里保留你的署名。",
  },
  {
    id: "faq-4",
    question: "讨论区的观点会经过筛选吗？",
    answer:
      "我们会清理与话题无关、明显失实或带有攻击性的内容，但不会因为立场不同就删掉观点。讨论区存在的意义，正是让多种声音能够被看到。",
  },
  {
    id: "faq-5",
    question: "在讨论区参与互动需要注册账号吗？",
    answer:
      "浏览所有话题内容都不需要注册。当前阶段发表观点、点赞等互动为演示体验，后续我们会开放更完整的社区功能，让每一次参与都能被记录下来。",
  },
];

export const siteVoices = [
  {
    id: "voice-1",
    user: "夜猫子小李",
    handle: "@night_owl_li",
    text: "习惯睡前刷一刷讨论区，别人一句话就能点破我自己想不到的角度，比一个人瞎想有意思多了。",
    topic: "影视剧讨论区",
  },
  {
    id: "voice-2",
    user: "通勤吃瓜人",
    handle: "@commute_melon",
    text: "地铁上十分钟能看完一个话题的前因后果，讨论区的整理帖真的救了我这种时间碎片的人。",
    topic: "综艺话题整理",
  },
  {
    id: "voice-3",
    user: "造型研究所",
    handle: "@style_lab",
    text: "红毯盘点那期讨论让我重新理解了剪裁，之前只看颜色，现在会看门道了。",
    topic: "时尚造型讨论区",
  },
  {
    id: "voice-4",
    user: "现场连线员",
    handle: "@live_wire",
    text: "音乐节那天我在讨论区从傍晚连线到散场，虽然没到现场，但氛围一点没落下。",
    topic: "音乐现场连线",
  },
];

export const sitePrinciples = [
  {
    id: "principle-1",
    title: "围绕事实讨论",
    desc: "我们欢迎各种观点，但更看重讨论的依据。有出处、有对比、有推理的观点，永远是讨论区里最受欢迎的。",
    icon: "ri-scales-3-line",
  },
  {
    id: "principle-2",
    title: "保留多元声音",
    desc: "同一个话题，允许有不同的答案。我们不追求一致，只希望每一种认真的表达都能被听见。",
    icon: "ri-chat-voice-line",
  },
  {
    id: "principle-3",
    title: "尊重每一位围观群众",
    desc: "讨论可以热烈，但不针对个人。理性与善意，是瓜田连线能一直聊下去的前提。",
    icon: "ri-heart-3-line",
  },
  {
    id: "principle-4",
    title: "内容有实际阅读价值",
    desc: "每一条话题都尽量给出背景、脉络和值得聊的点，让你看完之后能带走些什么，而不只是图个热闹。",
    icon: "ri-book-open-line",
  },
];

export const siteTimeline = [
  {
    id: "step-1",
    year: "起步",
    title: "从一篇观后感开始",
    desc: "最早只是一个记录追剧感受的小角落，因为写得实在，慢慢聚集了第一批喜欢一起聊的围观群众。",
  },
  {
    id: "step-2",
    year: "生长",
    title: "把讨论区做起来",
    desc: "我们发现，最有意思的内容往往藏在评论里。于是开始把不同观点整理成话题，让讨论本身成为内容。",
  },
  {
    id: "step-3",
    year: "现在",
    title: "瓜田连线，持续更新",
    desc: "如今黑瓜吃料覆盖六大话题方向，每天都有新的讨论在发生。我们希望它一直是那个可以随时来坐坐的地方。",
  },
];